// Soft gate for the IP allowlist. Intentionally renders nothing so the page
// leaks no information about the allowlist (no message, no IP, no "request
// access" hint) to non-whitelisted networks. Real enforcement is at the BFF;
// this just avoids exposing that an allowlist exists.
const IPBlockedPage = () => null;

export default IPBlockedPage;
